<template>
 <ValidationObserver ref="formObserver" v-slot="{ handleSubmit }">
   <form @submit.prevent="handleSubmit(onSubmit)">
      <div class="rounded-lg bg-smoke-100 py-4 px-2 lg:px-4 md:py-7.5 md:px-12 xl:px-56">
        <div class="flex border-b border-dark-b">
          <div class="text-xl md:text-2xl font-semibold">
            Order Summary
          </div>
        </div>
        <div class="flex flex-wrap w-full pt-12">
          <div class="lg:pr-5 w-full lg:w-1/2 text-lg lg:text-xl">
            <div class="lg:pb-3 font-semibold">Product Category
              <span class="text-red-600">*</span>
            </div>
            {{ summaryRecords.sourcing_request.product_category }} 
          </div>
          <div class="lg:pl-5 pt-6 lg:pt-0 text-lg lg:text-xl w-full lg:w-1/2">
            <div class="lg:pb-3 font-semibold">Product Sub Category<span class="text-red-600">*</span>
            </div>
             {{summaryRecords.sourcing_request.product_sub_category}}
           
          </div>     
        </div>
        <div class="w-full pt-6 lg:pt-10 lg:pr-5 font-semibold text-lg lg:text-xl leading-5 lg:leading-normal">
          Product Name And Description<span class="text-red-600 pr-2">*</span>
          <span class="text-base font-normal"><br class="lg:hidden"/>(Max 1000 Characters)</span>
          <div class="font-normal pt-2 lg:pt-0" v-html="summaryRecords.sourcing_request.product_description"></div>
        </div>
        <div class="flex w-full pt-6 lg:pt-12 text-lg lg:text-xl">
          <div class="lg:pr-5 w-1/2">
            <div class="lg:pb-3 font-semibold">Quantity
              <span class="text-red-600">*</span>
            </div>
            {{ summaryRecords.sourcing_request.product_quantity }}
          </div>
          <div class="lg:pl-5 lg:w-1/2">
            <div class="lg:pb-3 font-semibold">Shipping terms
              <span class="text-red-600">*</span>
            </div>
            {{ summaryRecords.sourcing_request.product_shipping_terms }}            

          </div>     
        </div>
        <div class="flex w-full pt-7 lg:pt-12 text-lg lg:text-xl">
          <div class="lg:pr-5 w-1/2">
            <div class="pb-2 font-semibold">Packing Details
              <span class="text-red-600">*</span>
            </div>
            <div class="font-normal pt-2 lg:pt-0" v-html="summaryRecords.sourcing_request.product_packaging_details"></div>
          </div>
         <div class="lg:pl-5 lg:w-1/2">
            <div class="lg:pb-3 font-semibold tracking-tight lg:tracking-normal">Safety Standards
              <span class="text-red-600">*</span>
            </div>
            {{ summaryRecords.sourcing_request.product_safety_standards }}
          </div>     
        </div>
        <div class="flex flex-wrap w-full pt-7 lg:pt-12 text-lg lg:text-xl">
          <div class="lg:pr-5 w-full lg:w-1/2">
            <div class="lg:pb-3 font-semibold">Product Images</div>
            <div class="grid grid-cols-2 gap-2">
              <div 
                v-for="(image, index) in summaryRecords.sourcing_request.product_images"
                :key="`image-${index}`"
              >
                <img :src="image.pdf_cover_url? image.pdf_cover_url : image.image_url">
              </div>
            </div>
          </div>
          <div class="lg:pl-5 w-full pt-7 lg:pt-0 lg:w-1/2">
            <div class="lg:pb-3 font-semibold">Product Links</div>
            <div 
              v-for="link in summaryRecords.sourcing_request.product_links"
              :key="link"
              class="flex flex-col gap-5 lg:gap-3">
              <a :href="link" target="_blank" class="text-blue underline mr-3 truncate">{{ link }}</a>
            </div>
          </div>     
        </div>
        <div class="flex flex-wrap w-full pt-7 lg:pt-12 text-lg lg:text-xl">
          <div class="lg:pr-5 w-full lg:w-1/2">
            <div class="pb-2 font-semibold">Target Price
            </div>
            {{ summaryRecords.sourcing_request.product_target_price }}            
          </div>
          <div class="lg:pl-5 w-full pt-7 lg:pt-0 lg:w-1/2">
            <div class="lg:pb-3 font-semibold">Decoration Specifications
            </div>
            <div v-html="summaryRecords.sourcing_request.product_decoration_details"></div>
          </div>
        </div>
        <div class="border-b border-dark-b pt-9 lg:pt-13 text-xl lg:text-2xl font-semibold">
          Supplier Selection Criteria
        </div>
        <div class="pt-7 lg:pt-12 w-full text-lg lg:text-xl">
          <div class="pb-2 lg:pb-0 font-semibold">Project Description or Special Requirement</div>
          <div v-if="summaryRecords.sourcing_request.supplier_special_requirement">
            <div v-html="summaryRecords.sourcing_request.supplier_special_requirement"></div>
          </div>
        </div>
        <div class="flex flex-wrap w-full pt-5 lg:pt-13 text-lg lg:text-xl">
          <div class="lg:pr-5 w-full lg:w-1/2">
            <div class="pb-1 lg:pb-2 font-semibold leading-5 lg:leading-normal">Any Audits or Compliance
              Certificates required?
            </div>
            <div v-if="summaryRecords.sourcing_request.supplier_compliance_requirement">
              <div class="font-normal pt-2 lg:pt-0" v-html="summaryRecords.sourcing_request.supplier_compliance_requirement"></div>
            </div>
          </div>
          <div class="lg:pl-5 pt-5 lg:pt-0 w-full lg:w-1/2">
            <div class="pb-1 lg:pb-2 font-semibold leading-5 lg:leading-normal">
              What countries/regions do you want your Sourcing Expert to find suppliers in? 
            </div>
            <span
              v-for="(loc, index) in display_regions"
              :key="`region-${index}`"
            >
              <span v-if="index === 2">&</span>
              <span v-else-if="display_regions.length >= 2 && index === 1">,</span>
                {{ loc }}
            </span>
          </div>
        </div>
        <div class="flex flex-wrap w-full pt-5 lg:pt-6">
          <div class="lg:pr-5 w-full lg:w-1/2 text-lg lg:text-xl">
            <div class="pb-1 font-semibold">Standard questions your Sourcing Expert will ask the suppliers</div>
            <ul class="list-inside mt-3 list-disc font-normal leading-5 lg:leading-normal">
              <li class="m-2">Who are your top 3 largest customers?</li>
              <li class="m-2">What is your top 3 export markets?</li>
              <li class="m-2">Which are your top 3 best-selling products?</li>
              <li class="m-2">What is your manufacturing speciality?</li>
              <li class="m-2">What are your lead times and payment terms?</li>
              <li class="m-2">What is the closest FOB Port?</li>
              <li class="m-2">What is your monthly production capacity?</li>
              <li class="m-2">Are you a manufacturer or an agent?</li>
              <li class="m-2">
                Are your products available for my market to distribute on an
                exclusive basis?
              </li>
              <li class="m-2">
                What product certifications or factory audit certifications do you
                have? (A copy will be requested)
              </li>
            </ul>
          </div>
          <div class="lg:pl-5 pt-7 lg:pt-0 w-full lg:w-1/2 text-lg lg:text-xl">
            <div class="pb-1 font-semibold">Up to three custom questions you would like to ask the suppliers</div>
            <div
              v-for="(question, index) in summaryRecords.sourcing_request.custom_questions"
              :key="index"
              class="flex flex-col gap-3 text-lg pt-3"
            >
              <div>{{ index+1 }}. <div v-html="question.replaceAll('\n', '<br/>')"></div></div>
            </div>
          </div>     
        </div>
        <div class="border-b border-dark-b pt-7 lg:pt-12 text-xl lg:text-2xl font-semibold">
          Payment Summary
        </div>
        <div class="flex flex-wrap w-full pt-4 text-lg lg:text-xl min-h-96">
          <div class="lg:pr-5 w-full lg:w-8/12">
            <div class="bg-white border rounded-md h-full">
              <div class="px-3 py-5 lg:py-5-5 lg:px-7 p-6 font-semibold">
                Paid By Credit Card
                <div  class="pt-1 lg:pt-0 pb-5 lg:pb-7 font-normal">
                  <p>XXXX XXXX XXXX {{ summaryRecords.order_details.payment.payment_info.last_4_digits }}</p>
                </div>
                Billing Address
                <div v-if="summaryRecords.order_details.billing_address" class="pt-1 pb-5 lg:pb-6 font-normal leading-6">
                  <span v-if="summaryRecords.order_details.billing_address.flat_no"> {{ summaryRecords.order_details.billing_address.flat_no }} ,</span>
                  <span v-if="summaryRecords.order_details.billing_address.building_name"> {{ summaryRecords.order_details.billing_address.building_name }} ,</span>
                  <span> {{ summaryRecords.order_details.billing_address.address_line1 }} ,</span>
                  <span v-if="summaryRecords.order_details.billing_address.address_line2"> {{ summaryRecords.order_details.billing_address.address_line2 }} ,</span>
                  <span> {{ summaryRecords.order_details.billing_address.city }} ,</span>
                  <span> {{ summaryRecords.order_details.billing_address.region }} ,</span>
                  <span> {{ countryName }} </span>
                  <span> {{ summaryRecords.order_details.billing_address.postcode }} </span>
                </div>
                <div  class="flex flex-wrap pb-6">
                  <div class="w-full lg:w-1/2">
                    City
                    <div class="font-normal">{{summaryRecords.order_details.billing_address.city }}</div>
                  </div>
                  <div class="w-full lg:w-1/2 pt-7 lg:pt-0">
                    Postal Code
                    <div class="font-normal">{{ summaryRecords.order_details.billing_address.postcode }}</div>
                  </div>
                </div>
                Country
                <div  class="font-normal">{{ countryName }}</div>
              </div>
            </div>
          </div>
          <div class="lg:pl-5 w-full pt-7 lg:pt-0 lg:w-4/12">
            <div class="bg-white border rounded-md h-full">
              <div class="px-5 lg:px-4 py-5 lg:py-6">
                <div class="text-center text-base border-b border-blue pb-3">
                  Once you confirm & pay,<br/>we will match your order to a<br/>
                  Sourcing Expert within 2-3 working days.<br/>After the match is confirmed,<br/>
                  your Sourcing Expert will get<br/>started on the project.
                </div>
                <div class="flex justify-between font-semibold pt-6">
                  <div class="text-lg">
                    Order Amount
                  </div>
                  <div 
                    class="text-xl tracking-tighter line-through font-normal w-content pr-2"
                    ref="orderPrice"
                    style="color: #FF0000"
                  >
                    US {{roundeOffPrice(summaryRecords.totals.order_total)}}
                  </div>
                </div>
                <div class="flex justify-between font-semibold pt-4 border-b pb-4 border-dark-b">
                  <div class="text-lg">
                    Launch Special
                  </div>
                  <div 
                    class="text-xl tracking-tighter"
                    :style="{'width': priceDivsWidth() + 'px'}"
                  >
                    US {{roundeOffPrice(summaryRecords.totals.launch_special)}}
                  </div>
                </div>
                <div class="flex justify-between font-semibold pt-3 text-blue pb-6">
                  <div class="text-lg">
                    Total
                  </div>
                  <div 
                    class="text-xl tracking-tighter w-content"
                    :style="{'width': priceDivsWidth() + 'px'}"  
                  >
                    US {{roundeOffPrice(summaryRecords.totals.grand_total)}}
                  </div>
                </div>
                <ValidationProvider
                  v-slot="{ errors }"
                  :rules="{ required: { allowFalse: false } }"
                  class="block w-full md:pr-2"
                >
                  <div class="flex items-center">
                    <input value="" v-model="formData.acceptTerms" type="checkbox" class="w-5 h-5">
                    <label
                      class="ml-2 cursor-pointer text-sm"
                      @click="formData.acceptTerms = !formData.acceptTerms"
                    >
                      I Agree to
                       <a :href="termsLink" class="text-blue underline" target="_blank">
                        Terms & Conditions
                      </a>
                    </label>
                  </div>
                  <div v-if="errors[0]" class="input-error">
                    <span>Please accept terms and conditions</span>
                  </div>
                </ValidationProvider>
              </div>
            </div>
          </div>     
        </div>
        <div class="flex lg:justify-end justify-center pt-6 my-8">
          <button 
            class="p-3 px-4 text-blue rounded-full border-2 border-blue text-lg lg:text-xl tracking-tighter lg:tracking-normal font-semibold mr-8" 
            :class="{'opacity-25': isButtonDisable}"
            :disabled="isButtonDisable"
            type="button"
            @click="$emit('editDetails')"
          >
            Edit Details
          </button>
          <button
            class="p-3 bg-blue text-white rounded-full text-lg lg:text-xl tracking-tighter lg:tracking-normal font-semibold" 
            :class="{'opacity-25': isButtonDisable}"
            :disabled="isButtonDisable"
            type="submit"
          >
            Confirm & Pay
          </button>
        </div>
      </div> 
   </form>
   <div class="text-center not-ready-section pb-3 pt-6">
        Not ready to commit? Questions? Let’s talk <br class="md:hidden"/> about your needs!
        <br/>
    </div>
    <div class="flex justify-center items-center">
      <button @click="getBookACallUrl" class="bg-theme  text-white rounded-full py-2 px-5 text-lg lg:text-xl font-semibold">
        Book a Call
      </button>
    </div>
  </ValidationObserver>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import countriesArray from '@/assets/json/countries.json'

export default {
  name: "Summary",
  props:{
    summaryRecordProp:{
      type:Object,
      default:null
    },
  },

   watch: {
    summaryRecords() {
      this.display_regions = this.summaryRecords.sourcing_request.supplier_region.map(region => {
      return region === 'Korea, Republic of' ? 'South Korea' : region
      })
      this.summaryRecords.sourcing_request.product_description = this.summaryRecords.sourcing_request.product_description.replaceAll('\n', '<br/>')
      this.summaryRecords.sourcing_request.product_packaging_details = this.summaryRecords.sourcing_request.product_packaging_details.replaceAll('\n', '<br/>')
      if(this.summaryRecords.sourcing_request.product_decoration_details) {
        this.summaryRecords.sourcing_request.product_decoration_details = this.summaryRecords.sourcing_request.product_decoration_details.replaceAll('\n', '<br/>')
      }
      this.summaryRecords.sourcing_request.supplier_compliance_requirement = this.summaryRecords.sourcing_request.supplier_compliance_requirement.replaceAll('\n', '<br/>')
      if(this.summaryRecords.sourcing_request.supplier_special_requirement) {
        this.summaryRecords.sourcing_request.supplier_special_requirement = this.summaryRecords.sourcing_request.supplier_special_requirement.replaceAll('\n', '<br/>')
      }
    }
  },

  data() {
    return {
      formData: {},
      isButtonDisable: false,
      termsLink: process.env.VUE_APP_BUYER_TERMS,
      display_regions: [],
      countriesArray,
      summaryRecords: {}
    };
  },
  computed: {
    ...mapGetters([
      'isUserLoggedIn',
      'getOrderSummary'
    ]),
    countryName() {
      return this.summaryRecords.order_details.billing_address.country === 'KR'
      ? 'South Korea'
      : this.countriesArray.find(country => country.code === this.summaryRecords.order_details.billing_address.country).name
    },
  },
  beforeMount() {
    if (!this.isUserLoggedIn) {
      this.LoginSelectionMode('buyer')
      this.$router.push({name: 'LoginFormv2'})
    }
    this.summaryRecords =  this.getOrderSummary 
  },
  methods: {
    ...mapActions([
      'completePlaceOrder',
      'LoginSelectionMode'
    ]),
    ...mapMutations([
      'setUserData',
      'setCurrentTab',
      'setSourcingRequestToken'
    ]),
    getBookACallUrl() {
      window.open(process.env.VUE_APP_BOOK_A_CALL_URL,'_blank');      
    },
    priceDivsWidth() {
      return this.$refs.orderPrice ? this.$refs.orderPrice.clientWidth : '80'
    },
    roundeOffPrice(price) {
      return `$${parseInt(price.substring(price.indexOf(" ")+1, price.length)).toFixed()}`
    },
    loadImage(image) {
      return (window.URL || window.webkitURL).createObjectURL(image)
    },
    async onSubmit() {
      this.isButtonDisable = true
      if (this.formData.acceptTerms) {
        const { checkout_link } = this.summaryRecords
        let response = await this.completePlaceOrder(checkout_link)
        if (response.result) {
          this.$emit('setReferenceNumber', response.order_reference_number)
          this.$emit('proceedNext')
          let userFormData = {
            companyData: null,
            productData: null,
            supplierData: null,
            paymentData: null,
          }
          this.setUserData(userFormData)
          this.setCurrentTab(null)
          this.setSourcingRequestToken(null)
        } else {
          this.$notify({
            group: 'buyHive',
            type: 'error',
            text: response.message,
            duration: 10000
          })
        }
      }
      this.isButtonDisable = false
    },
  }
};
</script>
<style lang="scss" scoped>
.not-ready-section {
  @screen md {
  font-size: 26px;
  line-height: 39px;
  font-weight: 700;
  }
  font-size: 24px;
  line-height: 28px;
  font-weight: 600;
}
</style>
